import React, { useState } from 'react';
import './Header.css';
import logo from '../assets/images/logo.png';

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="header">
      <img alt="Logo" src={logo} className="logo" id="header-logo" />
      <div className="menu-icon" onClick={() => setIsOpen(!isOpen)}>
      ☰
      </div>
      <nav className={`nav-links ${isOpen ? 'open' : ''}`}>
        <a href="https://www.meatthebun.ca/" className="header-link">Home</a>
        <a href="https://meatthebun.ca/about" className="header-link">About Us</a>
        <a href="https://meatthebun.ca/contact-us" className="header-link">Apply for Franchise</a>
      </nav>
    </header>
  );
}

export default Header;